import AppIcon from '../../../components/AppIcon';
import { formatNumber } from '../../../utils/formatNumber';

const TemplateCard = ({ template, onEdit, onPreview, onDuplicate, onSimulateSend }) => {
  const categoryIcons = {
    booking: 'CheckCircle',
    photographer: 'Camera',
    payment: 'DollarSign',
    account: 'User'
  };

  const categoryColors = {
    booking: 'var(--color-success)',
    photographer: 'var(--color-secondary)',
    payment: 'var(--color-accent)',
    account: 'var(--color-primary)'
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden hover:shadow-lg transition-shadow">
      {/* Header */}
      <div className="p-4 border-b border-border">
        <div className="flex items-start justify-between mb-2">
          <div className="flex items-center gap-2">
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center"
              style={{ backgroundColor: `${categoryColors?.[template?.category]}20` }}
            >
              <AppIcon 
                name={categoryIcons?.[template?.category]} 
                size={16} 
                color={categoryColors?.[template?.category]}
              />
            </div>
            <div>
              <h3 className="font-semibold text-foreground text-sm">{template?.name}</h3>
            </div>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            template?.status === 'active' ?'bg-success/10 text-success' :'bg-muted text-muted-foreground'
          }`}>
            {template?.status === 'active' ? 'نشط' : 'غير نشط'}
          </span>
        </div>
        <p className="text-xs text-muted-foreground">{template?.description}</p>
      </div>
      {/* Body Preview */}
      <div className="p-4 bg-muted/30">
        <p className="text-xs font-medium text-muted-foreground mb-1">الموضوع:</p>
        <p className="text-sm text-foreground mb-3 line-clamp-1">{template?.subject}</p>
        <p className="text-xs font-medium text-muted-foreground mb-1">المحتوى:</p>
        <p className="text-xs text-muted-foreground line-clamp-3 whitespace-pre-line">
          {template?.body}
        </p>
      </div>
      {/* Footer */}
      <div className="p-4 border-t border-border">
        <div className="flex items-center justify-between text-xs text-muted-foreground mb-3">
          <div className="flex items-center gap-1">
            <AppIcon name="Calendar" size={14} />
            <span>{template?.lastModified}</span>
          </div>
          <div className="flex items-center gap-1">
            <AppIcon name="Send" size={14} />
            <span>{formatNumber(template?.usageCount?.toString())} إرسال</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(template)}
            className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
          >
            <AppIcon name="Edit" size={16} />
            <span className="text-sm font-medium">تحرير</span>
          </button>
          <button
            onClick={() => onSimulateSend?.(template)}
            className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            title="محاكاة إرسال (وضع تجريبي)"
          >
            <AppIcon name="Send" size={16} />
            <span className="text-sm font-medium">إرسال تجريبي</span>
          </button>
          <button
            onClick={() => onPreview(template)}
            className="flex items-center justify-center gap-2 px-3 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium"
          >
            <AppIcon name="Eye" size={16} />
            <span>معاينة</span>
          </button>
          <button
            onClick={() => onDuplicate(template)}
            className="flex items-center justify-center px-3 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors"
            title="تكرار"
          >
            <AppIcon name="Copy" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;